export const openModal = {
  methods: {
    openModal (num) {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', num)
      document.body.classList.add('body-stop')
    }
  }
}

export const closeModal = {
  methods: {
    closeModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', false)
      document.body.classList.remove('body-stop')
      this.$store.dispatch('FORM_SUCCESS', false)
    }
  }
}

export const openVideo = {
  methods: {
    openVideo () {
      this.$store.state.video ? this.$store.dispatch('VIEW_VIDEO', false) : this.$store.dispatch('VIEW_VIDEO', true)
      // this.$store.state.video ? document.body.classList.remove('body-stop') : document.body.classList.add('body-stop')
    }
  }
}



// WEBPACK FOOTER //
// ./src/methods.js